import { Alert, Spin } from "antd";

import { ApiService } from "api/api.service";

const MissingBankPeriods = ({ appkey }: { appkey?: string }) => {
  const { data, isLoading, isFetching } = ApiService.upstream.useGetMissingBankPeriods(appkey);

  if (!appkey) {
    return null;
  }

  if (isLoading || isFetching) {
    return (
      <Alert
        type="info"
        showIcon
        closable
        icon={<Spin size="small" />}
        description="We're checking your bank statements for any missing periods."
        style={{ padding: "8px 12px" }}
      />
    );
  }

  const message = data?.result?.message;

  if (!message) {
    return null;
  }

  return (
    <Alert
      type="warning"
      showIcon
      closable
      description={<div style={{ whiteSpace: "pre-line" }}>{message}</div>}
      style={{ padding: "8px 12px" }}
    />
  );
};

export default MissingBankPeriods;
